import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert'
import { CheckCircle, CircleAlert } from 'lucide-react'
import PropTypes from 'prop-types'

export default function AlertMessage({ type = 'success',icon:Icon, title, message,className }) {
  const isSuccess = type === 'success'

  return (
    <Alert
      variant={isSuccess ? 'default' : 'destructive'}
      className={`flex items-start gap-3 ${className}`}
    >
      {Icon?<>{Icon}</>:<> {isSuccess ? <CheckCircle /> : <CircleAlert />}</>}
     
      <div className='w-full'>
        {title&&<AlertTitle>{title}</AlertTitle>}
        
        <AlertDescription>{message}</AlertDescription>
      </div>
    </Alert>
  )
}

AlertMessage.propTypes = {
  type: PropTypes.oneOf(['success', 'error']),
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  className: PropTypes.string,
}
